import React, { useEffect, createElement } from 'react';
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
const PIXEL_ID = '1601016194665913';
export function MetaPixel() {
  useEffect(() => {
    // Prevent double-initialization
    if (window.fbq) return;
    // Official Meta Pixel base code (exact copy from Meta Business Suite)
    const n: any = window.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!window._fbq) window._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    // Load the fbevents.js script
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);
    // Initialize with Advanced Matching (empty object enables the feature)
    window.fbq('init', PIXEL_ID, {});
    window.fbq('track', 'PageView');
    window.fbq('track', 'ViewContent', {
      content_name: '30 Recetas Anti-Inflamatorias para Mascotas',
      content_category: 'E-book',
      content_type: 'product',
      value: 19999,
      currency: 'COP'
    });
  }, []);
  return <noscript data-id="element-1281">
      <img height="1" width="1" style={{
      display: 'none'
    }} src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-1282" />
    </noscript>;
}
// Helper function to track InitiateCheckout — use this from any component
export function trackInitiateCheckout(value: number = 19999, numItems: number = 1) {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'InitiateCheckout', {
      content_name: '30 Recetas Anti-Inflamatorias para Mascotas',
      content_category: 'E-book',
      content_type: 'product',
      value: value,
      currency: 'COP',
      num_items: numItems
    });
  }
}